module.exports = __webpack_public_path__ + "img/Kale-Salad.ffe63905.jpg";